// import { Box } from '@mui/system';
import dynamic from 'next/dynamic';
import React, { Suspense } from 'react';

import ProgressiveChart from '../ProgressiveChart';
// import clock from '../../Loader/loading-chart.gif';
// import { hasPremiumAccess } from '../../helpers/utils';
// import ChartSkeleton from '../Common/Skeleton/Pages/StockSkeleton/Default';
// import Chart from './Chart';
const Chart = dynamic(() => import('./Chart'), {
  ssr: false,
})
// const Chart = React.lazy(() => import('./Chart'));

const D3Chart = props => {
  const { login, isLoginRedirect, chartHeight } = props || {};
  return (
    // <Suspense
    //   fallback={<div className={`chart-loader ${props.cssClass || ''}`}><img src={clock} loading="lazy" alt="loading..." /></div>}
    // >
    //   {hasPremiumAccess(login, isLoginRedirect) ?
    <Chart {...props} />
    // :
    // <ChartSkeleton
    //   isLoginRedirect={isLoginRedirect}
    //   login={login}
    //   chartHeight={chartHeight}
    // />}
    // </Suspense>
  );
}

export default ProgressiveChart(D3Chart);
